import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const styles = {
  container: "odules__Compute__Components__ComputeCard__styles_ts-container-c2b2zjx",
  content: "odules__Compute__Components__ComputeCard__styles_ts-content-c1xguyhw",
  footer: "odules__Compute__Components__ComputeCard__styles_ts-footer-f1u7olj1"
};

require("./styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");